import { render } from "./DataBoxes.vue?vue&type=template&id=ae34511e&scoped=true"
import script from "./DataBoxes.vue?vue&type=script&lang=js"
export * from "./DataBoxes.vue?vue&type=script&lang=js"

import "./DataBoxes.vue?vue&type=style&index=0&id=ae34511e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae34511e"]])

export default __exports__